import React from 'react';

import { PageHero } from '../../_components/PageHero';
import { PageHeroProps } from './types';

import classes from './index.module.scss';

export const PageHeroGraphQL: React.FC<PageHeroProps> = props => {
  const {
    id,
  } = props;

  return (
    <div id={`block-${id}`} className={classes.blockWrapper}>
      <PageHero pageHero={props} />
    </div>
  );
};

export default PageHeroGraphQL;
